// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1mUUR","loader":"Spinner_loader__3-lYD","load4":"Spinner_load4__1mBRC"};